import { Box, CircularProgress, Typography } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { getSingleVideoAction } from "../../store/actions/video/comments";
import Category from "../Home/components/Category/Category";
import Comments from "./components/Comments/Comments";
import VideoDetails from "./components/VideoDetails";
import VideoPlayer from "./components/VideoPlayer";

function InteractiveVideo() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const data = useSelector((s) => s?.video?.post?.type?.video);
  const isPending = useSelector((s) => s?.video?.loading);

  const thisPage = useSelector((s) => s?.video?.thisPage);
  const allPages = useSelector((s) => s?.video?.allPages);
  const loading = useSelector((s) => s?.video?.loading);

  const fetchVideo = useCallback(
    ({ page, limit, next }) => {
      getSingleVideoAction({ postId: id, page, limit, next })(dispatch);
    },
    [dispatch, id]
  );

  useEffect(() => fetchVideo({ page: 1, limit: 5 }), [fetchVideo]);

  const loadMoreComments = useCallback(
    (e) => {
      if (loading) return;
      if (thisPage === allPages) return;
      fetchVideo({ next: true, limit: 5 });
    },
    [allPages, fetchVideo, loading, thisPage]
  );

  return (
    <>
      {isPending ? (
        <Box
          sx={{ width: 1, display: "flex", justifyContent: "center", py: 8 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <VideoPlayer video={data} data={data?.media} />
          <VideoDetails video={data} />
          <Comments loadMoreComments={loadMoreComments} />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "start",
              px: "1.5em",
              pt: "1em",
              gap: "1em",
            }}
          >
            <Typography
              variant="h4"
              fontWeight={700}
              sx={{
                color: "#323232",
              }}
            >
              Related videos
            </Typography>
          </Box>
          {data?.categories?.length > 0 &&
            data?.categories?.map((category) => (
              <Category category={category} />
            ))}
        </>
      )}
    </>
  );
}

export default InteractiveVideo;
